import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction} from "../components/CustomToast/actions";

export const LOADED_ANNOUNCEMENTS = '[announcements] Loaded announcements';
export const LOADED_ANNOUNCEMENTS_PAGES = '[announcements] Loaded pages';
export const LOADED_ANNOUNCEMENTS_TOTAL = '[announcements] Loaded total';
export const LOADED_ANNOUNCEMENTS_CURRENT = '[announcements] Loaded current';
export const LOADED_ANNOUNCEMENTS_LIMIT = '[announcements] Loaded limit';
export const SET_ANNOUNCEMENT = '[announcement] Set announcement';

export const LoadAnnouncementsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Announcements')))
        .then(() => MindsetsJsSDK().API.get('announcements', options))
        .then(response => {
            dispatch(LoadedAnnouncementsAction(response.items));
            dispatch(LoadedAnnouncementsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedAnnouncementsLimitAction(response.limit));
            dispatch(LoadedAnnouncementsPagesAction(response.pages));
            dispatch(LoadedAnnouncementsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedAnnouncementsAction = payload => ({
    type: LOADED_ANNOUNCEMENTS,
    payload
});
export const LoadedAnnouncementsPagesAction = payload => ({
    type: LOADED_ANNOUNCEMENTS_PAGES,
    payload
});
export const LoadedAnnouncementsTotalAction = payload => ({
    type: LOADED_ANNOUNCEMENTS_TOTAL,
    payload
});
export const LoadedAnnouncementsCurrentAction = payload => ({
    type: LOADED_ANNOUNCEMENTS_CURRENT,
    payload
});
export const LoadedAnnouncementsLimitAction = payload => ({
    type: LOADED_ANNOUNCEMENTS_LIMIT,
    payload
});
export const DeleteAnnouncementAction = (id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`announcements/${id}`, options))
        .then(() => dispatch(LoadingAction(false)));
};
export const MoveAnnouncementUpAction = (announcement_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.patch(`announcements/${announcement_id}/up`, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const MoveAnnouncementDownAction = (announcement_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.patch(`announcements/${announcement_id}/down`, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const LoadAnnouncementAction = (announcement_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.get(`announcements/${announcement_id}`, options))
        .then(response => {
            dispatch(SetAnnouncementAction(response.announcement));
            dispatch(LoadingAction(false));

            return response.announcement;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetAnnouncementAction = payload => ({
    type: SET_ANNOUNCEMENT,
    payload
});
export const CreateAnnouncementAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post('announcements', data, options))
        .then(() => dispatch(LoadingAction(false)));
};
export const UpdateAnnouncementAction = (announcement_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`announcements/${announcement_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};
